import { useBaseComponent } from 'basics/component/base-component';
import { ReactElement } from 'react';
import { iconSelector } from 'utils/fileUtils';
import { FileViewerImage } from './FileViewer-style';
import { IFileViewerProps } from './FileViewer-type';
import ZipViewer from './ZipViewer';
import { getViewType } from '../../store/companies/companiesTypes';
import { HideOnMobile } from '../../utils/style/extendable';
import PdfViewer from './PdfViewer';
import OfficeViewer from './OfficeViewer';

export const MaxZipViewerSize = 50 * 1024 * 1024;
export const FileViewer = (props: IFileViewerProps): ReactElement => {
  useBaseComponent<IFileViewerProps>({ props });

  const { fileMimeType, url, size } = props;
  const fileType = getViewType(fileMimeType || '');
  if (fileType === 'zip' && size && size < MaxZipViewerSize) {
    return <ZipViewer fileUrl={url as string} />;
  }

  if (fileType === 'audio') {
    return (
      <div className="flex justify-center">
        <audio src={url} controls />
      </div>
    );
  }

  if (fileType === 'video') {
    return (
      <div className="flex justify-center">
        <video
          src={url}
          style={{ maxWidth: '100%', maxHeight: '100%', margin: '0 auto' }}
          controls
        />
      </div>
    );
  }

  if (fileType === 'pdf') {
    return (
      <HideOnMobile style={{ width: '100%', height: '100%' }}>
        <PdfViewer pdfURL={url as string} name={''} />
      </HideOnMobile>
    );
  }
  if (fileType === 'image') {
    return (
      <FileViewerImage
        style={{ maxWidth: '100%', maxHeight: '100%', margin: '0 auto' }}
        src={url ?? iconSelector(fileMimeType)}
      />
    );
  }

  if (fileType === 'office') {
    return <OfficeViewer fileUrl={url as string} fileType={fileMimeType} />;
  }

  return (
    <FileViewerImage
      style={{ maxWidth: '100%', maxHeight: '100%', margin: '0 auto' }}
      src={iconSelector(fileMimeType)}
    />
  );
};
